import styled from 'styled-components'

export const StyledAdmin = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f3f4f8;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  justify-content: flex-start;
  box-sizing: border-box;
`
